import type { TimelineNode } from "@/mocks/gossip";

export default function EventTimeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <ol className="relative border-l-2 border-background-200 pl-6 md:pl-8 space-y-8">
      {nodes.map((n, idx) => (
        <li key={`${n.time}-${idx}`} className="relative">
          <span
            className={`absolute -left-[31px] md:-left-[39px] top-1 w-4 h-4 rounded-full border-[3px] ${
              idx === 0
                ? "bg-primary-500 border-primary-200"
                : idx === nodes.length - 1
                ? "bg-accent-500 border-accent-200"
                : "bg-background-50 border-background-300"
            }`}
            aria-hidden="true"
          ></span>
          <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
            <div className="flex flex-wrap items-center gap-3">
              <time className="font-heading font-bold text-sm md:text-base text-primary-700">
                {n.time}
              </time>
              <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] text-accent-800">
                {n.tag}
              </span>
              {idx === 0 && (
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-[11px] text-primary-800">
                  时间线起点
                </span>
              )}
            </div>
            <h3 className="mt-2 font-heading font-semibold text-base md:text-lg text-foreground-950">
              {n.title}
            </h3>
            <p className="mt-1.5 font-label text-sm leading-relaxed text-foreground-600">{n.detail}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}